import styled from 'styled-components';
import { mobile, tablet } from '../../../utils/breakpoints';

export const Section = styled.section`
  background-image: url(${({ backgroundImage }) => backgroundImage});
  background-position: right;
  background-size: cover;
  background-repeat: no-repeat;
`;

export const Wrapper = styled.div`
  max-width: 1200px;
  padding: 70px;
  margin: 0 auto;

  @media (max-width: ${mobile.max}px) {
    padding: 22px;
  }
`;

export const Contents = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: stretch;

  @media (max-width: ${tablet.max}px) {
    justify-content: space-around;
  }

  @media (max-width: ${mobile.max}px) {
    display: block;
    margin-bottom: 30px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/profiles/styles/profiles.style.js